import {
  LicenseManager
} from 'ag-grid-enterprise'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const licenseKey = config.public.agGridLicenseKey
  if (licenseKey) {
    LicenseManager.setLicenseKey(licenseKey)
  }
})
